import { useEffect, useState } from "react";
import { config } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";

const useCityLogic = () => {
  const initFields = [
    {
      name: "name",
      label: "City name",
      type: "text",
      isRequired: true,
      err: "city Name is required",
      span: 3,
    },
    {
      name: "region",
      label: "Region",
      type: "dropdown",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Region is required",
      returnID: true,
    },
    // Add more fields as needed
  ];

  //Roles
  const apiRoute = "cities";
  const onlyForm = undefined;
  //const captain = process.env.REACT_APP_CAPTAIN_ID;
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole];

  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      fields: ["name", "region"],
      allowedRoles: [admin, managerRole, financeRole],
    },
  ];
  const [tabsData, setTabsData] = useState([]);

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      // Check if the variable is loaded
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        // Delete the interval
        clearInterval(interval);
      }
    }, 100); // Check every 100 milliseconds

    return () => {
      setTabsData([]);
    };
  }, []);
  const getPromises = (temp) => {
    return [fetchDataAndMapToField(config, "cities/regions", "region", temp)];
  };
  return {
    apiRoute,
    initFields,
    onlyForm,
    getPromises,
    tabs,
    tabsData,
    addRoles,
    deleteRoles,
    editRoles,
  };
};

export default useCityLogic;
